export default __webpack_public_path__ + "static/media/uitra_s.fd55f910.png";